import ApiBase from "./ApiBase";



export default class SiteCoreItem {
    static getPagePublishingState( successCallback, errorCallback, alwaysCallback) {
        return ApiBase.getData("/api/sitecoreitem/getpagepublishingstate", null, successCallback, errorCallback, alwaysCallback);
    }
    
}
